const shouldHotjarMaskReportColumn = keyName =>
  keyName === 'tenant' ||
  keyName === 'client_name' ||
  keyName === 'root_domain_auth' ||
  keyName === 'connection_name';

export default shouldHotjarMaskReportColumn;
